import script from "./LiteLanding.vue?vue&type=script&setup=true&lang=js"
export * from "./LiteLanding.vue?vue&type=script&setup=true&lang=js"

import "./LiteLanding.vue?vue&type=style&index=0&id=b761e060&scoped=true&lang=css"

import exportComponent from "/builds/skilltech-ph/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b761e060"]])

export default __exports__